import { /*generateAddPBXToCart*/ } from '../reducers/statics/consts'
import { toggleAddOnFeature, UPDATE_ADD_ON_FEATURES } from './DialingPlansActions'

export const SET_PBX_PLAN = "SET_PBX_PLAN";
export const SELECT_PBX_PLAN = "SELECT_PBX_PLAN";

export const setPbxPlan = (data) => {
    return (dispatch) => {
        dispatch({type: SET_PBX_PLAN, newData: data})
    }
}

export const selectPbxPlan = (planId, planPrice) => {
    return (dispatch, getState) => {
        const { HostedPbxPlan } = getState().HostedPbxReducer;
        if(HostedPbxPlan.id == planId && planId != "FREE") {
            planId = "FREE";
            planPrice = 0;
            
            //making sure the active agaent panel is off and its price isn't showing when FREE pbx selected
            var { AddOnFeatures } = getState().DialingPlansReducer;
            if(AddOnFeatures.find(item => item.id == "ACTIVE_AGENT_PANEL")) {
                AddOnFeatures = AddOnFeatures.filter(item => item.id != "ACTIVE_AGENT_PANEL");
                dispatch({type: UPDATE_ADD_ON_FEATURES, AddOnFeatures})
            }    

        }
        // fetch(generateAddPBXToCart(planId), {method: "POST"})
        // .then(r => r.status)
        // .then(resCode => console.log(resCode))
        // .catch(err => console.log(err))
        dispatch({type: SELECT_PBX_PLAN, planId, planPrice})
    }
}
